module.exports = __webpack_public_path__ + "img/ic_arrow_back_grey.08df740c.svg";